import WebVitals from './WebVitalsReporter';

export default WebVitals;
